export const appDownload = {
  // 下载应用
  DOWNLOAD_DOWNLOAD_CLICK: '8141.0',
  CMS_DOWNLOAD_CLICK: '1016.0'
}

export const appOpen = {
  // 打开APP
  DOWNLOAD_OPEN_CLICK: '10086.0',
  CMS_OPEN_CLICK: '10087.0'
}
